import * as React from "react";
const SvgFiRrMapMarkerCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 24a5.41 5.41 0 0 1-3.807-1.552L4.25 18.805C2.144 16.7 1 13.938 1 11s1.144-5.701 3.222-7.778A10.93 10.93 0 0 1 12 0c2.938 0 5.7 1.144 7.778 3.222A10.92 10.92 0 0 1 23 11c0 2.939-1.144 5.7-3.222 7.778l-3.992 3.689A5.4 5.4 0 0 1 12 24m0-22a8.94 8.94 0 0 0-6.364 2.636A8.94 8.94 0 0 0 3 11a8.94 8.94 0 0 0 2.636 6.364l3.936 3.635c1.336 1.306 3.542 1.286 4.837.02l3.984-3.682A8.92 8.92 0 0 0 21 11.001a8.95 8.95 0 0 0-2.636-6.364A8.94 8.94 0 0 0 12 2m-.094 12.419 5.793-5.707a1 1 0 0 0-1.404-1.425l-5.809 5.701-2.793-2.707A1 1 0 0 0 6.3 11.717l2.782 2.696c.391.391.903.585 1.416.585s1.021-.193 1.407-.58z"
    />
  </svg>
);
export default SvgFiRrMapMarkerCheck;
